import { AHIcon, AHText, AHTextFonts, Box } from "arkh";
import { useFragment, graphql } from "react-relay";
import { TeamFeatureItem } from "./TeamFeatureItem";
import { useIntlTokens } from "../../../../../components/mobile/useIntlTokens";
import { TeamFeatureBarKPIItem_KPITeamFeature$key } from "./__generated__/TeamFeatureBarKPIItem_KPITeamFeature.graphql";
import { useMemo } from "react";

export function TeamFeatureBarKPIItem(props: {
  feature: TeamFeatureBarKPIItem_KPITeamFeature$key;
  onPress: () => void;
  isGrid: boolean;
}) {
  const feature = useFragment(
    graphql`
      fragment TeamFeatureBarKPIItem_KPITeamFeature on KPITeamFeature {
        KPIRoutines {
          occasions(first: 1) {
            edges {
              node {
                occasionSections(teamId: $teamId) {
                  id
                  taskExecutions {
                    ... on TaskExecutionNumber {
                      isCompleted
                    }
                  }
                }
              }
            }
          }
        }
      }
    `,
    props.feature
  );

  const intl_tokens = useIntlTokens();

  const { completedTasks, totalTasks } = useMemo(() => {
    let completedTasks = 0;
    let totalTasks = 0;
    feature.KPIRoutines.forEach((routine) => {
      routine.occasions.edges.forEach((occasion) => {
        occasion.node.occasionSections.forEach((section) => {
          section.taskExecutions.forEach((task) => {
            totalTasks++;
            completedTasks += task.isCompleted ? 1 : 0;
          });
        });
      });
    });

    return {
      completedTasks,
      totalTasks,
    };
  }, [feature]);

  const isCompleted = totalTasks === completedTasks;
  return (
    <TeamFeatureItem
      isGrid={props.isGrid}
      icon={<AHIcon type="KPI" />}
      title={intl_tokens.KPIs}
      onPress={props.onPress}
      right={
        totalTasks === 0 ? null : (
          <Box
            space="xxsmall"
            spaceHorizontal="xsmall"
            cornerRadius="large"
            style={{
              flexDirection: "row",
              alignSelf: "flex-start",
              alignItems: "center",
              borderWidth: 1,
            }}
            borderColor={isCompleted ? "border-primary" : "primary"}
            color={isCompleted ? "surface" : "primary"}
          >
            <AHText
              font={AHTextFonts.BOLD}
              size={9}
              spaceRight="small"
              spaceLeft="xsmall"
              color={isCompleted ? "text-secondary" : "text-inverted"}
            >
              {completedTasks} / {totalTasks}
            </AHText>
            <AHIcon
              type="chevron-right"
              color={isCompleted ? "text-secondary" : "text-inverted"}
              size="xsmall"
            />
          </Box>
        )
      }
    />
  );
}
